import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 自動再リース */
enum AutoReLease {
  yes = '1',
  no = '2',
}

const nameConfig = {
  yes: new Map([
    [Locale.ja, '自動再リースする'],
    [Locale.en, 'Re-lease Automatically'],
  ]),
  no: new Map([
    [Locale.ja, '自動再リースしない'],
    [Locale.en, 'Do Not Re-lease Automatically'],
  ]),
};

const toEnum = rawValueToEnum(AutoReLease, AutoReLease.yes);
const toDisplay = enumToName(AutoReLease, nameConfig);
const toDisplayWithPrefix = enumToName(AutoReLease, nameConfig, { prefix: true });

export const autoReLease = {
  enum: AutoReLease,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { AutoReLease };
